const types = {
  CLEAR_CURRENT: 'INITIATIVE_ASSISTANCES_CLEAR_CURRENT',
  GET_REQUEST: 'INITIATIVE_ASSISTANCES_GET_REQUEST',
  GET_SUCCESS: 'INITIATIVE_ASSISTANCES_GET_SUCCESS',
  GET_FAILURE: 'INITIATIVE_ASSISTANCES_GET_FAILURE',

  SAVE_REQUEST: 'INITIATIVE_ASSISTANCES_SAVER_REQUEST',
  SAVE_SUCCESS: 'INITIATIVE_ASSISTANCES_SAVE_SUCCESS',
  SAVE_FAILURE: 'INITIATIVE_ASSISTANCES_SAVE_FAILURE',

  GETALL_REQUEST: 'INITIATIVE_ASSISTANCES_GETALL_REQUEST',
  GETALL_SUCCESS: 'INITIATIVE_ASSISTANCES_GETALL_SUCCESS',
  GETALL_FAILURE: 'INITIATIVE_ASSISTANCES_GETALL_FAILURE',

  DELETE_REQUEST: 'INITIATIVE_ASSISTANCES_DELETE_REQUEST',
  DELETE_SUCCESS: 'INITIATIVE_ASSISTANCES_DELETE_SUCCESS',
  DELETE_FAILURE: 'INITIATIVE_ASSISTANCES_DELETE_FAILURE',    

  UPDATE_REQUEST: 'INITIATIVE_ASSISTANCES_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'INITIATIVE_ASSISTANCES_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'INITIATIVE_ASSISTANCES_UPDATE_FAILURE'    

};

export default types;